export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["接受"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["清除"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["需要管理决定"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["未接受"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已接受"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["活动"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["是"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["否"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["代币可以在ATM购买"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["代币可以在ATM出售"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["类别"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["资产参考代币（ART代币）"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["电子货币代币（EMT代币）"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["非ART代币或EMT代币的加密资产"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["其他"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["二级市场代币"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["应用"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["全部清除"])}
}